import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails = () => {
  const fertilizerData = {
    title: "Utpann Kesari Phos",
    category: "Phosphate Rich Organic Manure (PROM)",
    image: "/assets/Product/img1.png",
    description:
      "UTPANN Kesari Phos is a high-quality organic phosphorus-rich fertilizer that strengthens root development and boosts early crop vigor. It improves soil fertility while enhancing nutrient availability for better flowering, fruiting, and yield. Designed for sustainable farming, Kesari Phos supports long-term soil health and higher farmer profitability.",
    price: "1250",
    priceNote: "Per 50 kg Bag (Gujarat)",
    recommendations: ["All Crops", "Better Crop Quality", "High Yield"],
    specsTitle: "FCO-1985 Technical Specifications",
    specs: [
      { label: "Moisture% by weight maximum", value: "25%" },
      {
        label: "Particle Size",
        value: "Minimum 90% Material Should Pass through 4.0mm IS sieve",
      },
      { label: "Total Organic Carbon minimum:", value: "8.0%" },
      { label: "Total Phosphates minimum", value: "8.0%" },
      { label: "Conductivity (as dSm-1)", value: "Not more than 10.0" },
      { label: "pH", value: "6.5-8.0" },

      { label: "Pathogens", value: "Nil" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000kg FIBC" },
      { label: "Standard Bags", value: "50kg" },
      { label: "Containers", value: "20ft & 40ft available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Enriches soil with essential nutrients and organic matter",
      "Enhances crop growth, flowering, and yield",
      "Improves soil structure and moisture retention",
      "Eco-friendly and safe for sustainable farming practices",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={fertilizerData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails;
